/**
 * 播放状态管理
 *
 * 不负责真正播放
 * 只负责状态
 */

import {TTS_STATUS} from "../constants/TTSConstants";

export default class PlaybackManager {
    constructor() {
        this.status = TTS_STATUS.IDLE;
    }

    /**
     * 开始播放
     */
    start() {
        this.status = TTS_STATUS.PLAYING;
    }

    /**
     * 停止
     */
    stop() {
        this.status = TTS_STATUS.STOPPED;
    }

    /**
     * 空闲
     */
    idle() {
        this.status = TTS_STATUS.IDLE;
    }

    /**
     * 是否播放中
     */
    isPlaying() {
        return this.status === TTS_STATUS.PLAYING;
    }

    /**
     * 当前状态
     */
    getStatus() {
        return this.status;
    }

}